import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Accordion, Card, Dropdown, Modal } from 'react-bootstrap';
import Radio from '@material-ui/core/Radio';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { useSelector, useDispatch } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory, Redirect } from 'react-router-dom';
import { analytics, logEvent }  from "~/services/firebaseConfig";

import {
  BackIcon,
  Background,
  MainContainer,
  Title,
  SubTitle,
  InputQuantity,
  TextQuantity,
  SelectProduct,
  AlignDropdownBranch,
  IconProductStyles,
  CardHeader,
  ContainerButton,
  ImgTitle,
  AlignProducts,
  DivisionQuantityButtons,
} from './styles';
import '~/components/styles/Global.css';
import api from '~/services/api';
import { InfoButton, OutlineGrayButton } from '~/components/layout/Buttons';
import Items from '~/components/pages/Order/Items';
import SummaryOrder from '~/components/pages/Order/Summary';
import OrderType from '~/components/pages/Order/OrderType';
import ObservationComponent from '~/components/pages/Order/Observation';
import HeaderMobile from '~/components/layout/HeaderOld';
import IconProduct from '~/components/layout/IconProduct';
import Loading from '~/components/layout/Loading';
import OpenChatBot from '~/components/layout/Chatbot';

import back from '~/assets/images/arrow.svg';
import p13Cinza from '~/assets/images/botijao-p13-cinza.svg';
import { verifyRoles } from '~/utils/functions/verifyRoles';

export default function Order({ desktop, activeModalOrder, isModalActive }) {
  const items = useSelector(state => state.orderReducer.items);
  const products = useSelector(state => state.orderReducer.products);
  const observation = useSelector(state => state.orderReducer.observation);
  const orderSummary = useSelector(state => state.orderReducer.order);
  const date = useSelector(state => state.orderReducer.date);
  const selectedBranch = useSelector(
    state => state.orderReducer.selectedBranch,
  );
  const orderReducer = useSelector(state => state.orderReducer);
  const dispatch = useDispatch();
  const history = useHistory();

  const [loadingPage, setLoadingPage] = useState(true);
  const [shippingMode, setShippingMode] = useState('');
  const [product, setProduct] = useState('');
  const [quantity, setQuantity] = useState(0);
  const [expand, setExpand] = useState(false);
  const [branches, setBranches] = useState([]);
  const [productIndex, setProductIndex] = useState(0);
  const [openItems, setOpenItems] = useState(true);
  const [zero, setZero] = useState(false);
  const [modalObservation, setModalObservation] = useState(false);
  const [textObservation, setTextObservation] = useState('Nenhuma observação');
  const [writingTextarea, setWritingTextarea] = useState('');
  const [desktopObservation, setDesktopObservation] = useState(false);
  const roles = useSelector(state => state.rolesReducer.roles);

  const addItem = item => {
    setQuantity(0);
    setProduct(products[0]);
    dispatch({ type: 'ADD_ITEM', item });
  };

  const addObservation = observation => {
    setTextObservation(writingTextarea);
    dispatch({ type: 'ADD_OBSERVATION', observation });
  };

  const modalObservationActive = bringResult => {
    if (bringResult) {
      return modalObservation;
    } else {
      if (modalObservation) {
        setModalObservation(false);
      } else {
        setModalObservation(true);
      }
    }
  };

  const desktopObservationActive = bringResult => {
    if (bringResult) {
      return desktopObservation;
    } else {
      if (desktopObservation) {
        setDesktopObservation(false);
      } else {
        setDesktopObservation(true);
      }
    }
  };

  const addProducts = products => {
    dispatch({ type: 'ADD_PRODUCT', products });
  };

  const getProducts = () => {
    if (product === '') {
      dispatch({ type: "SET_ORDER_ITEMS", items: [] })
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('access_token'),
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };
      const url = `/residential/store/v1/stores/${localStorage.getItem(
        'storeId',
      )}/business-characteristics`;

      api
        .get(url, parameters)
        .then(res => {
          setBranches(res.data.supplyBranches);
          if(!localStorage.getItem("supplyBranchId")) {
            localStorage.setItem(
              'supplyBranchId',
              res.data.standardSupplyBranchId,
            );
          }
          localStorage.setItem(
            'standardServiceType',
            res.data.standardServiceType,
          );
          setShippingMode(res.data.standardShippingMode);
          addProducts(
            res.data.supplyBranches[selectedBranch ? selectedBranch : 0]
              .products,
          );
          setProduct(
            res.data.supplyBranches[selectedBranch ? selectedBranch : 0]
              .products[0],
          );
          setLoadingPage(false);
        })
        .catch(err => {
          const erro = err.response;
          if (erro.status === 404) {
            toast.error('Pedido de Abastecimento não disponível na sua região');
            setTimeout(() => {
              if (window.screen.width < 770) {
                history.push('/portal');
              } else {
                activeModalOrder();
              }
              setLoadingPage(false);
            }, 3500);
          }
          if (erro) {
            const message = err.response.data.message;
            if (erro.status !== 401) {
              toast.error(message);
            }
          } else {
            if (err.response.status !== 401) {
              toast.error("Ocorreu um erro interno na aplicação");
            }
          }
        });
    }
  };

  useEffect(() => {
    if (
      (desktop && orderReducer.activeModal.order) ||
      (desktop && orderReducer.errorOrder)
    ) {
      getProducts();
    }
    if (!desktop) {
      getProducts();
    }
  }, [selectedBranch]);

  useEffect(() => {
    if (orderReducer.orderTake) {
      setOpenItems(false);
    }
  }, []);

  const CustomSelect = React.forwardRef(({ children, onClick }, ref) => {
    return (
      <SelectProduct
        ref={ref}
        onClick={event => {
          event.preventDefault();
          onClick(event);
          expand ? setExpand(false) : setExpand(true);
        }}
      >
        <IconProduct productName={children} />
        <span>{children}</span>
        {expand ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </SelectProduct>
    );
  });

  const VerifyComponent = () => {
    if (
      (items.length > 0 && orderSummary.typeOrder === 'Retira') ||
      (items.length > 0 && orderSummary.typeOrder === 'Entrega')
    ) {
      if (date !== '') {
        return (
          <SummaryOrder branches={branches} textObservation={observation} />
        );
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  const HeaderComponent = () => (
    <>
      <HeaderMobile />
      <BackIcon
        onClick={() => {
          if (desktop) {
            activeModalOrder();
          } else {
            history.push('/portal');
            dispatch({ type: 'ORDER_DONE' });
          }
        }}
      >
        <img src={back} alt="Ícone para voltar" />
      </BackIcon>
    </>
  );

  return (
    <>
      {verifyRoles(roles, 'PEDIDO_DE_ABASTECIMENTO') ? (
        <>
          <Background>
            {loadingPage ? (
              <>
                {desktop ? null : <HeaderComponent />}
                <Loading />
              </>
            ) : (
              <>
                {desktop ? null : <HeaderComponent />}
                {shippingMode === "FOB - FROTA PROPRIA" ||
                shippingMode === "FOB - TERCEIRO" ? (
                  <MainContainer>
                    <Title>
                      <ImgTitle src={p13Cinza} alt="Ícone butijão" />
                      <span>Pedido de Abastecimento</span>
                    </Title>
                    <SubTitle>
                      Escolha o tipo de botijão para abastecimento
                    </SubTitle>
                    <OrderType
                      filiais={branches}
                      isFrotaPropria={true}
                      shippingMode={shippingMode}
                    />
                    <Items desktop={desktop} />
                    {date !== '' && (openItems || items.length < 1) ? (
                      <>
                        <Accordion defaultActiveKey="0">
                          <Card.Header style={CardHeader}>
                            Item - {items.length + 1}
                            {items.length < 1 ? null : (
                              <CloseIcon onClick={() => setOpenItems(false)} />
                            )}
                          </Card.Header>
                          <Card>
                            <Card.Body>
                              <Dropdown className="products">
                                <Dropdown.Toggle
                                  as={CustomSelect}
                                  id="dropdown-custom-components"
                                >
                                  {
                                    branches[
                                      selectedBranch ? selectedBranch : 0
                                    ].products[productIndex].name
                                  }
                                </Dropdown.Toggle>

                                <Dropdown.Menu style={{ width: '100%' }}>
                                  {branches[
                                    selectedBranch ? selectedBranch : 0
                                  ].products.map((element, index) => {
                                    return (
                                      <Dropdown.Item
                                        key={element.code}
                                        eventKey={`${element.code}`}
                                        onClick={() => {
                                          setProductIndex(index);
                                          setProduct(element);
                                        }}
                                        style={AlignDropdownBranch}
                                      >
                                        <AlignProducts>
                                          <Radio
                                            color="primary"
                                            checked={
                                              branches[
                                                selectedBranch
                                                  ? selectedBranch
                                                  : 0
                                              ].products[productIndex].name ===
                                              element.name
                                            }
                                          />
                                          <span className="product">
                                            {element.name}
                                          </span>{' '}
                                          <span className="align-icon">
                                            <IconProduct
                                              productName={element.name}
                                              styles={{
                                                p2: IconProductStyles,
                                                p5: IconProductStyles,
                                                p20: IconProductStyles,
                                                p45: IconProductStyles,
                                                p90: IconProductStyles,
                                                p13: IconProductStyles,
                                              }}
                                            />
                                          </span>
                                        </AlignProducts>
                                      </Dropdown.Item>
                                    );
                                  })}
                                </Dropdown.Menu>
                              </Dropdown>
                              <TextQuantity>Escolha a quantidade</TextQuantity>
                              <InputQuantity
                                type="number"
                                value={quantity === null || quantity < 0 ? 0 : quantity}
                                onFocus={() => {
                                  if (quantity === 0) {
                                    setQuantity(null);
                                  }
                                  logEvent(analytics, 'abastecimento_campo_digitacao');
                                }}
                                onChange={event => {
                                  if (event.target.value === '') {
                                    setZero(true);
                                  }
                                  const newValue = parseInt(event.target.value);
                                  if (typeof newValue === 'number') {
                                    setQuantity(newValue);
                                  }
                                }}
                              />
                              <DivisionQuantityButtons>
                                {[1, 10, 100].map(button => (
                                  <OutlineGrayButton
                                    className={`quantity-${button}`}
                                    margin={'1rem .5rem 1rem 0'}
                                    onClick={() => {
                                      logEvent(analytics, 'abastecimento_botoes_atalho');
                                      (zero && isNaN(quantity)) || (quantity < 0)
                                        ? setQuantity(button)
                                        : setQuantity(quantity + button);
                                    }}
                                  >
                                    +{button === 1 ? '01' : button}
                                  </OutlineGrayButton>
                                ))}
                              </DivisionQuantityButtons>
                              <InfoButton
                                style={{ marginTop: '.8rem' }}
                                onClick={() => {
                                  let possible = true;
                                  if (quantity > 0) {
                                    if (items.length > 0) {
                                      items.map(item => {
                                        if (
                                          item.product.name ===
                                          branches[
                                            selectedBranch ? selectedBranch : 0
                                          ].products[productIndex].name
                                        ) {
                                          toast.error(
                                            'Não é possível inserir produtos duplicados',
                                          );
                                          possible = false;
                                        }
                                      });
                                    }
                                    if (possible && product !== '') {
                                      let sendProduct =
                                        branches[
                                          selectedBranch ? selectedBranch : 0
                                        ].products[productIndex];
                                      addItem({
                                        id: items.length + 1,
                                        product: sendProduct,
                                        quantity,
                                      });
                                      setOpenItems(false);
                                    }
                                  }
                                }}
                              >
                                Confirmar
                              </InfoButton>
                            </Card.Body>
                          </Card>
                        </Accordion>
                      </>
                    ) : null}
                    {date !== '' ? (
                      <ContainerButton>
                        <OutlineGrayButton
                          onClick={() => {
                            setOpenItems(true);
                          }}
                        >
                          + Adicionar Mais Itens
                        </OutlineGrayButton>
                      </ContainerButton>
                    ) : null}
                    <ObservationComponent
                      modalObservationActive={modalObservationActive}
                      desktopObservationActive={desktopObservationActive}
                      addObservation={addObservation}
                      observation={observation}
                      date={date}
                      items={items}
                    />
                    <VerifyComponent />
                  </MainContainer>
                ) : (
                  // Não é FOB - FROTA PRÓPRIA
                  <MainContainer>
                    <Title>
                      <ImgTitle src={p13Cinza} alt="Ícone butijão" />
                      Pedido de Abastecimento
                    </Title>
                    <SubTitle>
                      Escolha o tipo de botijão para abastecimento
                    </SubTitle>
                    <Items />
                    {openItems || items.length < 1 ? (
                      <>
                        <Accordion defaultActiveKey="0">
                          <Card.Header style={CardHeader}>
                            Item - {items.length + 1}
                            {items.length < 1 ? null : (
                              <CloseIcon onClick={() => setOpenItems(false)} />
                            )}
                          </Card.Header>
                          <Card>
                            <Card.Body>
                              <Dropdown className="products">
                                <Dropdown.Toggle
                                  as={CustomSelect}
                                  id="dropdown-custom-components"
                                >
                                  {product.name}
                                </Dropdown.Toggle>

                                <Dropdown.Menu style={{ width: '100%' }}>
                                  {products.map(element => (
                                    <Dropdown.Item
                                      key={element.code}
                                      eventKey={`${element.code}`}
                                      onClick={() => setProduct(element)}
                                      style={AlignDropdownBranch}
                                    >
                                      <AlignProducts>
                                        <Radio
                                          color="primary"
                                          checked={
                                            branches[
                                              selectedBranch
                                                ? selectedBranch
                                                : 0
                                            ].products[productIndex].name ===
                                            element.name
                                          }
                                        />
                                        <span className="product">
                                          {element.name}
                                        </span>
                                        <span className="align-icon">
                                          <IconProduct
                                            productName={element.name}
                                            styles={{
                                              p2: IconProductStyles,
                                              p5: IconProductStyles,
                                              p20: IconProductStyles,
                                              p45: IconProductStyles,
                                              p90: IconProductStyles,
                                              p13: IconProductStyles,
                                            }}
                                          />
                                        </span>
                                      </AlignProducts>
                                    </Dropdown.Item>
                                  ))}
                                </Dropdown.Menu>
                              </Dropdown>
                              <TextQuantity>Escolha a quantidade</TextQuantity>
                              <InputQuantity
                                type="number"
                                value={quantity === null || quantity < 0 ? 0 : quantity}
                                onFocus={() => {
                                  if (quantity === 0) {
                                    setQuantity(null);
                                  }
                                }}
                                onChange={event => {
                                  if (event.target.value === '') {
                                    setZero(true);
                                  }
                                  const newValue = parseInt(event.target.value);
                                  if (typeof newValue === 'number') {
                                    setQuantity(newValue);
                                  }
                                }}
                              />
                              <DivisionQuantityButtons>
                                {[1, 10, 100].map(button => (
                                  <OutlineGrayButton
                                    className={`quantity-${button}`}
                                    margin={'1rem .5rem 1rem 0'}
                                    onClick={() => {
                                      logEvent(analytics, 'abastecimento_botoes_atalho');
                                      (zero && isNaN(quantity)) || (quantity < 0)
                                        ? setQuantity(button)
                                        : setQuantity(quantity + button);
                                    }}
                                  >
                                    +{button === 1 ? '01' : button}
                                  </OutlineGrayButton>
                                ))}
                              </DivisionQuantityButtons>
                              <InfoButton
                                style={{ marginTop: '.8rem' }}
                                onClick={() => {
                                  let possible = true;
                                  if (quantity > 0) {
                                    if (items.length > 0) {
                                      items.map(item => {
                                        if (
                                          item.product.name === product.name
                                        ) {
                                          toast.error(
                                            'Não é possível inserir produtos duplicados',
                                          );
                                          possible = false;
                                        }
                                      });
                                    }
                                    if (possible && product !== '') {
                                      addItem({
                                        id: items.length + 1,
                                        product,
                                        quantity,
                                      });
                                      setOpenItems(false);
                                    }
                                  }
                                }}
                              >
                                Confirmar
                              </InfoButton>
                            </Card.Body>
                          </Card>
                        </Accordion>
                      </>
                    ) : null}
                    <ContainerButton>
                      <OutlineGrayButton onClick={() => setOpenItems(true)}>
                        + Adicionar Mais Itens
                      </OutlineGrayButton>
                    </ContainerButton>
                    <ObservationComponent
                      modalObservationActive={modalObservationActive}
                      desktopObservationActive={desktopObservationActive}
                      addObservation={addObservation}
                      observation={observation}
                      date={date}
                      items={items}
                    />
                    {items.length > 0 ? <OrderType filiais={branches} /> : null}
                    <VerifyComponent />
                  </MainContainer>
                )}
              </>
            )}

          </Background>
        </>
      ) : (
        <Redirect to="/portal" />
      )}
    </>
  );
}
